// extracted by mini-css-extract-plugin
export default {"ratingContainer":"Rating_ratingContainer__1ANaL","iconContainer":"Rating_iconContainer__U35Qk","disabledIconContainer":"Rating_disabledIconContainer__Dr2uZ"};